/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AnyRedactedAutoTestStepAsJSON } from './AnyRedactedAutoTestStepAsJSON';
import { CheckPointsAsJSON } from './CheckPointsAsJSON';
import { CodeQualityAsJSON } from './CodeQualityAsJSON';
import { CustomOutputAsJSON } from './CustomOutputAsJSON';
import { IOTestAsJSON } from './IOTestAsJSON';
import { JunitTestAsJSON } from './JunitTestAsJSON';
import { RunProgramAsJSON } from './RunProgramAsJSON';
const AutoTestStepBaseParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    AnyRedactedAutoTestStepAsJSON,
    /* #__PURE__ */ parsers.lazy(() => 
    /* #__PURE__ */ parsers.taggedUnion('type', [
        ['io_test', IOTestAsJSON],
        ['run_program', RunProgramAsJSON],
        ['custom_output', CustomOutputAsJSON],
        ['check_points', CheckPointsAsJSON],
        ['junit_test', JunitTestAsJSON],
        ['code_quality', CodeQualityAsJSON],
    ])),
]);
export const AutoTestStepBase = AutoTestStepBaseParser;
